export default __webpack_public_path__ + "static/media/160.7bc0b566.png";